import { createSelector } from "reselect";
import { getNextBillingDate } from "./get-next-billing-date";

export const getMonthlyBillingDay = createSelector(
  getNextBillingDate,
  (billingDate) => {
    return billingDate && new Date(billingDate).getDate();
  }
);
